module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/fribourg-1bd38add91728b077fefda37e16ecafa.jpg";